var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"content home"},[_c('div',{staticClass:"container-fluid"},[_c('h2',{staticClass:"p-2"},[_vm._v("Bem vindo!")])])])
}]

export { render, staticRenderFns }